import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/person/list',
        method: 'get',
        params: query
    })
}

export function save(data) {
    return request({
        url: '/admin/person/save',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/person/batchUpdate',
        method: 'post',
        data
    })
}
